import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useProfile } from 'context/Profile'

const Guard = ( {
  children
} ) => {
  const profile = useProfile()
  const navigate = useNavigate()

  useEffect( () => {
    if ( ! profile.user )
      return navigate( '/auth/login' )
  } )

  return children
}

export default Guard
